import React, { FunctionComponent } from 'react';
import { Box, MenuItem, Select, Switch, TextField } from '@material-ui/core';
import styled from 'styled-components';
import { isNumber, isBoolean, isNaN } from 'lodash';

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 4px 0;
`;

type SettingInputRowProps<T extends number | boolean | string | undefined> = {
  value: T;
  onChange: (value: T) => void;
  defaultValue: T;
  options?: string[];
};

const SettingInput: FunctionComponent<SettingInputRowProps<number | boolean | string | undefined>> = ({
  value,
  onChange,
  defaultValue,
  options,
}) => (
  <InputWrapper>
    {isNumber(value) && (
      <TextField
        type="number"
        value={value}
        onChange={(e) => {
          const parsed = parseInt(e.target.value, 10);
          onChange(isNaN(parsed) ? defaultValue : parsed);
        }}
        style={{
          ...(value !== defaultValue && !isNaN(value)
            ? { fontWeight: 600, opacity: 0.85 }
            : { fontWeight: 300 }),
          backgroundColor: '#fff',
        }}
        onWheel={(event) => (event.target as HTMLInputElement)?.blur()}
        onBlur={() => onChange(isNaN(value) ? defaultValue : value)}
        placeholder={(defaultValue ?? {}).toString()}
        variant="outlined"
        size="small"
        inputProps={{
          style: { fontSize: 14, textAlign: 'right', padding: '6px 8px' },
        }}
      />
    )}
    {isBoolean(value) ? (
      <Box display="flex" justifyContent="center">
        <Switch checked={value} onChange={(_e, checked) => onChange(checked as any)} />
      </Box>
    ) : null}
    {options && (
      <Select
        displayEmpty
        value={value || ''}
        onChange={(e) => onChange(e.target.value as string)}
        variant="outlined"
        style={{ height: 35, fontSize: 14 }}
      >
        {options.map((option: string | number) => (
          <MenuItem style={{ height: 35 }} key={option ?? 'key'} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    )}
  </InputWrapper>
);

export default SettingInput;
